let general = {
    init: () => {
        const scrollBarWidth = window.innerWidth - document.body.offsetWidth + "px";
        document.body.style.setProperty("--scrollbar-width", scrollBarWidth);
    }
}
export default general;